/**
 * Easify <-> Vanga Bridge
 *
 * Sur les produits personnalisables (templates dans perso_templates), Easify
 * Product Options intercepte le clic du bouton "Ajouter au panier" et fait son
 * propre POST /cart/add.js via XMLHttpRequest, suivi d'une redirection vers
 * /cart. Vanga AI SmartCart patche window.fetch (mais pas XMLHttpRequest),
 * donc il ne capte pas ce POST et son drawer n'a aucune chance de s'ouvrir.
 *
 * Ce script intercepte le clic AVANT Easify (capture phase sur window), stoppe
 * Easify, et fait lui-meme un fetch /cart/add.js qui inclut :
 *   - tous les inputs du form Sense
 *   - tous les inputs properties[...] (que Easify rend hors du form)
 *
 * Le fetch est intercepte par Vanga (qui patche window.fetch), qui ouvre son
 * drawer normalement.
 *
 * Charge uniquement sur les templates produits personnalisables
 * (voir sections/main-product.liquid : assign perso_templates).
 *
 * Version: 2026-05-04-r1
 */
(function () {
  'use strict';

  var SUBMIT_SELECTOR = 'product-form [type="submit"]';
  var FORM_SELECTOR = 'product-form form[action$="/cart/add"]';

  function setLoading(btn, loading) {
    if (!btn) return;
    var spinner = btn.querySelector('.loading-overlay__spinner');
    if (loading) {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  function getErrorWrapper(form) {
    var pf = form.closest('product-form') || form.parentElement;
    return (pf && pf.querySelector('.product-form__error-message-wrapper')) ||
      form.querySelector('.product-form__error-message-wrapper') ||
      document.querySelector('.product-form__error-message-wrapper');
  }

  function showError(form, message) {
    var wrapper = getErrorWrapper(form);
    if (wrapper) {
      wrapper.removeAttribute('hidden');
      wrapper.style.removeProperty('display');
      var msg = wrapper.querySelector('.product-form__error-message');
      if (msg) msg.textContent = message;
      try { wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* noop */ }
    } else if (typeof window.alert === 'function') {
      window.alert(message);
    }
  }

  function hideError(form) {
    var wrapper = getErrorWrapper(form);
    if (wrapper) wrapper.setAttribute('hidden', '');
  }

  function buildFormData(form) {
    var data = new FormData(form);
    var propertyInputs = document.querySelectorAll(
      'input[name^="properties["], select[name^="properties["], textarea[name^="properties["]'
    );
    Array.prototype.forEach.call(propertyInputs, function (input) {
      if (form.contains(input)) return;
      if (input.disabled) return;
      if (input.type === 'file') {
        if (input.files && input.files[0]) {
          data.append(input.name, input.files[0]);
        }
      } else if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) data.append(input.name, input.value);
      } else {
        data.append(input.name, input.value == null ? '' : input.value);
      }
    });
    return data;
  }

  function openCartDrawer() {
    setTimeout(function () {
      var alreadyOpen = document.querySelector('#vanga-smartcart [class*="open"], #vanga-smartcart [class*="visible"]');
      if (alreadyOpen) return;
      var cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) cartIcon.click();
    }, 250);
  }

  function findEmptyRequiredEasifyInput() {
    var visibleTexts = document.querySelectorAll(
      '.po-textField-input, .po-element [type="text"], .po-element textarea'
    );
    for (var i = 0; i < visibleTexts.length; i++) {
      var input = visibleTexts[i];
      if (input.offsetParent === null) continue;
      if (input.value && input.value.trim().length > 0) continue;
      return input;
    }
    return null;
  }

  function focusInput(input) {
    try {
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { input.focus(); }, 200);
    } catch (e) { /* noop */ }
  }

  function handleClick(event) {
    var btn = event.target && event.target.closest(SUBMIT_SELECTOR);
    if (!btn) return;
    var productFormEl = btn.closest('product-form');
    var form = productFormEl && productFormEl.querySelector('form[action$="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    if (btn.getAttribute('aria-disabled') === 'true') return;

    var emptyRequired = findEmptyRequiredEasifyInput();
    if (emptyRequired) {
      showError(form, 'Veuillez remplir le texte de votre personnalisation avant de continuer.');
      focusInput(emptyRequired);
      return;
    }

    hideError(form);
    setLoading(btn, true);

    var data = buildFormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: data
    })
      .then(function (resp) {
        return resp.text().then(function (text) {
          var json = null;
          try { json = JSON.parse(text); } catch (e) { /* not JSON */ }
          return { ok: resp.ok, status: resp.status, body: json, raw: text };
        });
      })
      .then(function (result) {
        if (!result.ok || (result.body && result.body.status && result.body.status !== 200)) {
          var description =
            (result.body && (result.body.description || result.body.message)) ||
            'Une erreur est survenue lors de l\'ajout au panier. Merci de reessayer.';
          showError(form, description);
          return;
        }
        if (!result.body) {
          showError(form, 'Reponse inattendue du serveur. Merci de reessayer.');
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: result.body }));
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('[easify-vanga-bridge] add to cart failed:', err);
        showError(form, 'Une erreur est survenue lors de l\'ajout au panier. Merci de reessayer.');
      })
      .then(function () {
        setLoading(btn, false);
      });
  }

  function init() {
    window.addEventListener('click', handleClick, { capture: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
